import {landCommentsRequests} from '#/repository/fetch-land-comments';
import {InvestorInsightsFilter, Land} from '@shareland/shareland-common';
import {useQuery} from '@tanstack/react-query';
import {zeroAddress} from 'viem';

export const useLandComments = ({
  account,
  land,
  filter,
}: {
  account: string | undefined;
  land: Land | undefined;
  filter: InvestorInsightsFilter;
}) => {
  const targetAccount = account || zeroAddress;

  return useQuery({
    queryKey: ['comments', targetAccount, filter, land?.tokenSymbol],
    queryFn: () =>
      landCommentsRequests.get({
        land_token_symbol: land!.tokenSymbol,
        account: targetAccount!,
        filter,
        take: 10,
        page: 1,
      }),
    enabled: !!land && !!targetAccount,
  });
};
